import { MoneySchema } from "@redotech/money";
import * as z from "zod/v4";

export const getCheckoutTreeAnalytics = {
  name: "getCheckoutTreeAnalytics" as const,
  input: z.object({
    checkoutTreeId: z.discriminatedUnion("kind", [
      z.object({ kind: z.literal("split"), splitId: z.string() }),
      z.object({ kind: z.literal("current") }),
    ]),
  }),
  output: z
    .object({
      analyticsForCheckoutNodeByNodeId: z.record(
        z.string(),
        z.object({
          total: z.object({
            orders: z.object({ count: z.number() }),
            revenue: MoneySchema,
            shippingRevenue: MoneySchema,
          }),
          byRateTableId: z.record(
            z.string(),
            z.object({
              orders: z.object({
                count: z.number(),
                relativePercentage: z.number(),
              }),
              revenue: MoneySchema,
              shippingRevenue: MoneySchema,
            }),
          ),
        }),
      ),
    })
    .nullable(),
};
export type GetCheckoutTreeAnalyticsOutput = z.infer<
  typeof getCheckoutTreeAnalytics.output
>;
